module.exports = __webpack_public_path__ + "static/media/noticon.ce733cbd.svg";